import { useState } from 'react';
import { Button, Input } from '../ui/components';
import { useAppSelector, useAppDispatch } from '../store/hooks';
import { 
  increment, 
  decrement, 
  incrementByAmount, 
  selectCount 
} from '../store/slices/counterSlice';

const CounterPage = () => {
  const count = useAppSelector(selectCount);
  const dispatch = useAppDispatch();
  const [incrementAmount, setIncrementAmount] = useState('2');

  const handleIncrementByAmount = () => {
    const amount = Number(incrementAmount) || 0;
    dispatch(incrementByAmount(amount));
  };

  return (
    <div>
      <h1 style={{ fontSize: '1.5rem', fontWeight: 600, textAlign: 'center', marginBottom: 24, color: 'var(--ds-text-primary)' }}>
        Redux Counter Example
      </h1>
      
      <div style={{ padding: 32, maxWidth: 500, margin: '0 auto', border: '1px solid var(--ds-border-default)', borderRadius: 'var(--ds-border-radius-large)', backgroundColor: 'var(--ds-bg-primary)' }}>
        <div style={{ textAlign: 'center', marginBottom: 24 }}>
          <span style={{ fontSize: '3rem', fontWeight: 700, color: 'var(--ds-text-primary)' }} data-testid="count">
            {count}
          </span>
        </div>
        
        <div style={{ display: 'flex', gap: 12, justifyContent: 'center', marginBottom: 24 }}>
          <Button variant="primary" size="lg" onClick={() => dispatch(increment())}>
            Increment
          </Button>
          <Button variant="secondary" size="lg" onClick={() => dispatch(decrement())}>
            Decrement
          </Button>
        </div>
        
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 12 }}>
          <input
            type="number"
            value={incrementAmount}
            onChange={(e) => setIncrementAmount(e.target.value)}
            style={{ width: 100, padding: '8px 12px', border: '1px solid var(--ds-border-default)', borderRadius: 'var(--ds-border-radius-medium)', fontSize: '0.875rem' }}
          />
          <Button variant="secondary" onClick={handleIncrementByAmount}>
            Add Amount
          </Button>
        </div>
      </div>
      
      <div style={{ marginTop: 32, textAlign: 'center' }}>
        <p style={{ fontSize: '1rem', color: 'var(--ds-text-secondary)' }}>
          This counter is managed by Redux Toolkit.
        </p>
        <p style={{ fontSize: '0.875rem', color: 'var(--ds-text-secondary)' }}>
          Check the Redux DevTools to see the state changes.
        </p>
      </div>
    </div>
  );
};

export default CounterPage;
